export default "__VITE_ASSET__D63l81FI__"